import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { Subscription } from '../entities/subscription';
import { Observable, catchError, of, throwError } from 'rxjs';
import { SubscriptionDetail } from '../entities/subscription-detail';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Subscription[];
}

interface ApiResponseDetail {
  status: string;
  data: SubscriptionDetail[];
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private subscriptionServiceUrl = this.apiServicesUrl + '/subscription';

  getSubscriptions(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.subscriptionServiceUrl)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  getSubscriptionsByPerson(urlId: string): Observable<ApiResponseDetail> {
    return this.http.get<ApiResponseDetail>(this.subscriptionServiceUrl + '-detail/' + urlId)
    .pipe(
      catchError(err => { return throwError(() => err) })
    );
  }

  postSubscription(subscriptionDetail: SubscriptionDetail, urlId: string, days: number): Observable<ApiResponseDetail> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    let subscriptionDetailWithUrlId: {[key:string]: any} = {...subscriptionDetail};
    subscriptionDetailWithUrlId['urlId'] = urlId;
    subscriptionDetailWithUrlId['days'] = days;
    return this.http.post<ApiResponseDetail>(this.subscriptionServiceUrl + '-detail/', subscriptionDetailWithUrlId, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponseDetail>('postSubscription'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
